import { useMemo } from 'react'

const CONFETTI_COLORS = ['#C9A84C', '#debb5a', '#fff6c0', '#9a7a34', '#e8c96a', '#f0d878']

/**
 * Reusable confetti burst — same particle aesthetic used by the single-player
 * win screen. Renders as an absolutely-positioned overlay; the parent should
 * either be position:relative or this component should be placed inside a
 * full-screen container (the existing .confetti CSS handles the rest).
 */
export default function Confetti({ count = 55 }) {
  const particles = useMemo(() =>
    Array.from({ length: count }, (_, i) => ({
      id: i,
      left: `${(Math.random() * 100).toFixed(1)}%`,
      delay: `${(Math.random() * 2.2).toFixed(2)}s`,
      duration: `${(1.6 + Math.random() * 1.4).toFixed(2)}s`,
      width: `${(5 + Math.random() * 7).toFixed(1)}px`,
      height: `${(8 + Math.random() * 10).toFixed(1)}px`,
      color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
      endRotate: `${Math.floor(Math.random() * 900 + 360)}deg`,
      isCircle: Math.random() > 0.55,
    }))
  , [count])

  return (
    <div className="confetti" aria-hidden="true">
      {particles.map((p) => (
        <div
          key={p.id}
          className="confetti__piece"
          style={{
            left: p.left,
            animationDelay: p.delay,
            animationDuration: p.duration,
            width: p.width,
            height: p.isCircle ? p.width : p.height,
            background: p.color,
            borderRadius: p.isCircle ? '50%' : '2px',
            '--end-rotate': p.endRotate,
          }}
        />
      ))}
    </div>
  )
}
